import { useSignedInUser } from '../../Hooks/Hooks';

export default function Greeting() {
    const [ user ] = useSignedInUser();

    return (
        <div className="text-lg">Welcome {user?.name}</div>
    )
}